import React from "react";

import { FooterOverlay, Newsletter } from "../../components";
import { FiFacebook, FiTwitter, FiInstagram } from "react-icons/fi";
import "./Footer.css";
import { images } from "../../constants";

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">
          {" "}
          Raozan Munsirgata Ras Bihari Dam Chittagong, 4142, Bangladesh
        </p>
        <p className="p__opensans">+8801337423784</p>
        <p className="p__opensans">+134 8554930</p>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.gericht} alt="footer_logo"/>
        <p className="p__opensans">
          &quot;The Best Way to Find Yourself is to Lose Yourself in the Service
          of Others.&quot;
        </p>
        <img
          src={images.spoon}
          className="spoon__img"
          style={{ marginTop: 15 }}
          alt="spoon"
        />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday - Friday:</p>
        <p className="p__opensans">10.00 am - 06.00 pm</p>
        <p className="p__opensans">Saturday - Sunday</p>
        <p className="p__opensans">09.00 am - 07.00 pm</p>
      </div>
    </div>

    <div className="footer__copyright">
    <p className="p__opensans">All Rights Reserved © 2020 - 2022</p>
    </div>
  </div>
);

export default Footer;
